import { useDispatch, useSelector } from 'react-redux';
import { setPreAction, clearPreAction } from '../../redux/gameSlice';
import './PreActionPanel.css';

// The "pre-action" bar shown when the local player is still in the hand but it isn't their
// turn. Picking one queues it; the usePreActionAutoFire hook submits it the instant it becomes
// their turn. Clicking the selected option again clears it. Mutually exclusive with the live
// ActionPanel (which only shows on the player's turn).
const OPTIONS = [
    { key: 'check-fold', label: 'Check / Fold' },
    { key: 'check', label: 'Check' },
    { key: 'check-call-any', label: 'Check / Call Any' },
];

const PreActionPanel = ({ roomId }) => {
    const dispatch = useDispatch();
    const choice = useSelector((state) => state.games.preAction?.[roomId]);

    const toggle = (key) => {
        if (choice === key) dispatch(clearPreAction({ roomId }));
        else dispatch(setPreAction({ roomId, choice: key }));
    };

    return (
        <div className="pre-action-panel">
            {OPTIONS.map((opt) => (
                <button
                    key={opt.key}
                    className={`pre-action-btn${choice === opt.key ? ' selected' : ''}`}
                    onClick={() => toggle(opt.key)}
                >
                    <span className="pre-action-radio" />
                    {opt.label}
                </button>
            ))}
        </div>
    );
};

export default PreActionPanel;
